<template>
	<v-card outlined>
		<v-card-title class = "justify-center pa-0 primary white--text body-1">
			<span> {{ $ml.get(titleDialog) }}</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<p class = "caption mb-0">  <span> {{ $ml.get(textDialog) }}</span> </p>
				<!-- dashboard_item.show_field -->
				<v-text-field
					outlined dense
					type    		= "text"
					:label  		= "$ml.get('name')"
					v-model 		= "name_dashboard"
					v-show 			= "['create','update'].includes(typeForm)"
					:rules 			= "[errorMessageNameProfile]" 
				></v-text-field>
				<v-select 						
					outlined 
					dense 
					v-model 		= "alertMode"
					:items  		= "listAlertModes"
					:label 			= "$ml.get('alert_mode')"
					v-show 			= "['create','update'].includes(typeForm)"
					item-value		= "key"
					text-value 		= "text"						
				>	
				 	<template v-slot:selection="{ item}">
				 		<span>{{$ml.get(item.text)}}</span>
				 	</template>
					<template v-slot:item="{item}">
						<span>{{ $ml.get(item.text) }}</span>
					</template>
				</v-select>
				<!-- dashboard_item.show_items -->
				<v-item-group 
					active-class = "primary"
					v-show 		 = "typeForm == 'confirm_dashboard'"
					v-model 	 = "selection"
				>
				    <v-container>
				      	<v-row
				      		dense
				      	>
					        <v-col
					          	v-for = "(item_dash, idx_dash) of renderDashboards"
					          	:key  = "idx_dash+'form_dashboard_menu_profile'"
					          	cols  = "12"
					          	md    = "4"
					        >
						        <v-item v-slot="{ active, toggle }" :value="item_dash">
						            <v-card
						              	dark
						              	class  = "d-flex align-center pl-1"
						              	height = "30"
						              	@click = "toggle"
						            >
						             	<v-icon x-small> mdi-view-dashboard </v-icon>
						              	<v-scroll-y-transition>
						              		<span class = "mx-1"> {{ item_dash.name }} </span>
						              	</v-scroll-y-transition>
						            </v-card>
						        </v-item>
				        	</v-col>
				        	<v-col cols="12"> <strong class="warning--text"> {{$ml.get("when_no_option_selected_dashboard")}} </strong> </v-col>
				      	</v-row>
				    </v-container>
				 </v-item-group>
				 <!-- !dashboard_item.show_field -->
				<v-progress-linear
				    v-model = "loadingValue"
				    :active = "loading && ['confirm_dashboard'].includes(typeForm) ? true : false"
				    :color  = "loadingColor"			
				    height  = "12"	    					    
				>
					<span class="caption">{{$ml.get('time_automatic_closing')}}</span>
				</v-progress-linear>
				<v-progress-linear
				    indeterminate
				    :active = "loading2"
				    color  = "success"			
				    height  = "12"	    					    
				></v-progress-linear>
				
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					small
					color  		= "success"
					v-text 		= "$ml.get('confirm')"
					@click 		= "confirmSelectionProfile()"
					v-show 	  	= "typeForm == 'confirm_dashboard'"
					:disabled	= "selection ? false : true "
				></v-btn>
				<!-- create_dashboard -->
				<v-btn
					small
					color  = "primary"
					v-text = "$ml.get('update')"
					@click = "update()"
					v-show = "typeForm == 'update'"
					:disabled = "!isValidConfirm"
				></v-btn>
					<!-- :disabled="!name_dashboard ? true : false" -->
					<!-- create_dashboard -->
				<v-btn
					small
					color  	  = "primary"
					v-text 	  = "$ml.get('confirm')"
					:disabled = "!isValidConfirm"
					@click    = "save()"
					v-show    = "typeForm == 'create'"
				></v-btn>
				<v-btn 
					small
					color  = "error"
					v-text = "$ml.get('close')"
					@click = "$emit('closeModal', false)"
				></v-btn>
			</v-card-actions>
		</v-card>
</template>
<script type="text/javascript">
	export default{
		name : "FormModalDashboard",
		props: ["typeForm", "renderDashboards", "currentProfile", "isDialogActive"],
		data : (vm)=>({
			loadingValue:0,
			loading:false,
			interval:null,
			loading2 : false, // create / update
			loadingColor:"primary",
			titleDialog:"",
			textDialog:"",
			selection : null,
			name_dashboard:"",
			isValidConfirm : false,
			alertMode : vm.currentProfile.alertMode,
			listAlertModes :[
				{ key : "snack" , text: "minimized" },  // minimized
				{ key : "alert" , text: "maximized" }, // maximized 
			],
		}),
		watch:{
			typeForm(val){
				this.renderTypeForm(val);
			},
			currentProfile: {
				handler(){
					if (this.typeForm == 'update' && this.isDialogActive) {
						this.renderTypeForm('update');
					}
				}
			},
			isDialogActive(val){
				if (val) {
					this.renderTypeForm(this.typeForm);
				}
			}
		},
		mounted(){
			this.renderTypeForm(this.typeForm);
		},
		methods:{
			confirmSelectionProfile(){
				if (this.selection) {
					// 1. Cambia todos los dashboards a 'active' excepto el seleccionado
					const updates = this.renderDashboards
						.filter(dash => dash.state === 'default' && dash.id !== this.selection.id)
						.map(dash => {
							console.log("Actualizando dashboard:", dash.id, dash.state);
							return this.$store.dispatch("Dashboard/updateList", { ...dash, state: 'active' });
						});

					// 2. Cambia el dashboard seleccionado a 'default'
					updates.push(
						this.$store.dispatch("Dashboard/updateList", { ...this.selection, state: 'default' })
					);

					Promise.all(updates).then(() => {
						this.$router.push({ 
							name:"dashboards",
							params : { id: this.selection.id }
						});
						this.$emit("closeModal", this.selection);
						this.$EventBus.$emit('notifications_modal',{
							type   : 'updated',
							message:  this.$ml.get('dashboard')
						});
					});
				}
			},
			errorMessageNameProfile(){
				if (this.name_dashboard) {
					if (this.currentProfile && this.currentProfile.name != this.name_dashboard) {
						if (this.renderDashboards.some(x=> x.name == this.name_dashboard)) {
							this.isValidConfirm=false;
							return this.$ml.get('ms_name_exist')
						}
					}
					this.isValidConfirm=true;
				}else{
					this.isValidConfirm=false;
				}
				return true
			},
			renderTypeForm(val){							
				if (val) {
					if (val=='create') {
						this.titleDialog="create_dashboard_profile"
						this.textDialog="ms_new_dashboard"
						this.name_dashboard=""
						this.alertMode=this.currentProfile?.alertMode || "snack";
						this.isValidConfirm=false;
					}else if (val=='update') {
						this.titleDialog="update_profile"
						this.textDialog="ms_rename_dashboard"
						this.name_dashboard=this.currentProfile?.name || "";
						this.alertMode=this.currentProfile?.alertMode || this.alertMode;
						this.isValidConfirm=!!this.name_dashboard;
					}else if (val=='confirm_dashboard') {
						this.titleDialog="select_dashboard"
						this.textDialog=""
						this.start_loading_close();
					}
				}
			},
			start_loading_close(){
			// 				dashboard_loading : {
 			// 	interval 	: null,
 			// 	value 		: 0, 	
 			// 	show 		:false,			
			// },
				this.loading = true;
				if (this.interval) {
					clearInterval(this.interval);
					this.loadingValue = 0;

				}
				this.interval = setInterval(()=>{
					this.loadingValue += 2;
					if (this.loadingValue == 80) {
						this.loadingColor = "warning";
					}
					if (this.loadingValue == 100) {
						this.loadingColor = "success";
					}
					if (this.titleDialog  != "select_dashboard") {
						clearInterval(this.interval);
						this.loading = false;				
						this.loadingColor = "primary";		
					}
					if (this.loadingValue >= 100) {
						clearInterval(this.interval);
						if (this.isDialogActive) {
							this.$emit("closeModal", false);
						}
						this.loading = false;
						this.loadingColor = "primary";		
						this.loadingValue = 0;
					}
				},200);
			}, // start_loading_close

			save(){		
				let item = this.currentProfile;
				let info_up = {...item};       
				info_up.name = this.name_dashboard; 	
        		info_up.alertMode   = this.alertMode;
        		info_up.module 		= "dashboard";
        		if (info_up.id) { delete info_up.id };
        		this.loading2=true;
        		// Sincroniza camVisibility antes de guardar
        		try {
        			this.$refs.parking?.syncCamVisibilityWithStore?.();
        		} catch (e) { /* ignora si no existe */ }
        		this.$store.dispatch("Dashboard/saveList",{
        			...info_up,
        		}).then(res=>{
        			if (res &&  res.data) {
        				info_up.id 	= res.data.id; 
        				// this.list_dashboards.unshift({...item});
        				this.$router.push({ 
        					name:"dashboards",
        					params : { id: info_up.id}//path : "/dashboard/" + item.id
        				});
        				// this.$store.commit("Dashboard/setCurrentProfile", {...info_up});
        				this.$store.commit("Dashboard/saveLocalProfile")
        				// this.dashboard_item.prevent_reload = true;
        				// this.renderAlertMode();
        				this.$emit('closeModal', false)
	        			this.$EventBus.$emit('notifications_modal',{
		        			type 	: 'saved',
		        			message :  this.$ml.get('dashboard')
		        		});
        			}else if(res?.message && res.message.includes("Error")){
        				this.$EventBus.$emit('notifications_modal',{
		        			type 	: 'error',
		        			message :  res
		        		});	
        			}
        			this.loading2=false;
        			
        			
        		}).catch(error=>{
        			console.log("Error create dashboards : ", error);
        			this.loading2=false;
        			this.$EventBus.$emit('notifications_modal',{
	        			type 	: 'error',
	        			message :  error
	        		});

        		})
			},

			update(){
				let item = this.currentProfile;
				let info_up = {...item};
				info_up.name = this.name_dashboard; 	
        		info_up.alertMode   = this.alertMode;
        		this.loading2=true;
        		
        		// Emitir evento para obtener camVisibility del componente parking
        		this.$EventBus.$emit('getCamVisibility');
        		
        		// Función para procesar la actualización con camVisibility
        		const processUpdate = async () => {
        			try {
        				// Obtener camVisibility del store
        			const camVisibility = this.$store.getters['Dashboard/camVisibility'] || {};
        				
        				// Sincronizar camVisibility en el store
        				await this.$store.dispatch('Dashboard/syncCamVisibility', camVisibility);
        			
        			// Inyectar camVisibility directamente en el dashboard
        			if (info_up.dashboard && Array.isArray(info_up.dashboard)) {
        				info_up.dashboard = info_up.dashboard.map(widget => {
        					if (widget.component === 'parking' || widget.component === 'register_events_parking') {
        						return { ...widget, camVisibility };
        					}
        					return widget;
        				});
        			}
        			
        				const res = await this.$store.dispatch("Dashboard/updateList", {
        				...info_up,
        				});
        				
        				if (res && res.data) {        				        				
        					this.$emit('closeModal', false)
	        				this.$EventBus.$emit('notifications_modal',{
		        				type 	: 'updated',
		        				message :  this.$ml.get('dashboard')
		        			});
        				} else if(res?.message && res.message.includes("Error")){
        					this.$EventBus.$emit('notifications_modal',{
		        				type 	: 'error',
		        				message :  res
		        			});	
        				}
        			} catch (error) {
        				console.log("Error update dashboards : ", error);
        				this.$EventBus.$emit('notifications_modal',{
	        				type 	: 'error',
	        				message :  error
	        			});
        			} finally {
        				this.loading2 = false;
        			}
        		};
        		
        		// Intentar procesar inmediatamente, si no hay camVisibility, esperar un poco
        		const camVisibility = this.$store.getters['Dashboard/camVisibility'];
        		if (camVisibility && Object.keys(camVisibility).length > 0) {
        			processUpdate();
        		} else {
        			// Si no hay camVisibility, esperar un poco más para que el componente responda
        			setTimeout(processUpdate, 200);
        		}
			},

			selectProfile(item) {
				// 1. Cambia todos los dashboards a 'active'
				this.renderDashboards.forEach(dash => {
					if (dash.state === 'default') {
						this.$store.dispatch("Dashboard/updateList", { ...dash, state: 'active' });
					}
				});

				// 2. Cambia el dashboard seleccionado a 'default'
				const updatedDashboard = { ...item, state: 'default' };
				this.$store.dispatch("Dashboard/updateList", updatedDashboard)
					.then(() => {
						this.currentProfile = updatedDashboard;
						// ... el resto de tu lógica de selección ...
					});
			},
		}
	}
</script>
